import React from 'react';
import Donationprogress from '../components/donationProgress';
import Trackdonation from '../components/trackdonationForm';
import { parseMessages } from '../../utilityHelper';

const templateData = $('body').data();
var slideIndex = 1;

function showSlides(n) {
  var i;
  var slides = document.getElementsByClassName("mySlides");
  var dots = document.getElementsByClassName("dot");
  if (n > slides.length) {slideIndex = 1}    
  if (n < 1) {slideIndex = slides.length}
  for (i = 0; i < slides.length; i++) {
      slides[i].style.display = "none";  
  }
  for (i = 0; i < dots.length; i++) {
      dots[i].className = dots[i].className.replace(" active", "");
  }
  slides[slideIndex-1].style.display = "block";  
  dots[slideIndex-1].className += " active";
}

function currentSlide(n) {
  showSlides(slideIndex = n);
}


const propertyInfo = parseMessages('trackdonation/dt-home');

export default class TrackDonationApp extends React.Component {
	constructor(props) {
		super(props)
		this.state = {
			trackDonationInfo:templateData.trackDonationInfo,
			propertyInfo:propertyInfo
		};
	}

	componentDidMount() {
		var slideIndex = 1;
		showSlides(slideIndex);
		$(".dotWrap .dot").on("click", function(){
		    console.log(this.id);
		    if (this.id == 'dot1'){
		    	currentSlide(1);
		    } else if (this.id == 'dot2') {
		    	currentSlide(2);
		    } else if (this.id == 'dot3') {
		    	currentSlide(3);
		    }
		});
	}
	render() {
		let trackDonationInfo = this.state.trackDonationInfo;
		let propertyInfoMessages = this.state.propertyInfo;
		return (
			<div id="donationTrackerWrapper" className="row">
				{templateData.trackDonationInfo.isResult ? <Donationprogress propertyInfo={propertyInfoMessages} trackDonationInfo={trackDonationInfo}/> : <div></div>}
				<Trackdonation propertyInfo={propertyInfoMessages} isResult={templateData.trackDonationInfo.isResult} trackanother={templateData.trackDonationInfo.trackanother}/>
			</div>
		);

	}
}


// WEBPACK FOOTER //
// ./trackdonation/components/trackdonationContainer.js